import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  pointer-events: none;

  .cell-contents {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 20px);
  }
`;

const Square = styled.span`
  background: ${props => props.color};
  width: 10px;
  height: 10px;
  margin-right: 10px;
`;

function CellStatus({ color, title, children }) {
  return (
    <Container title={title}>
      <Square color={color} />
      <span className="cell-contents">
        {children}
      </span>
    </Container>
  );
}

CellStatus.propTypes = {
  color: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export default CellStatus;